<template>
  <div v-if="visible" class="image-preview-layer" role="dialog" aria-modal="true" @click="onBackdrop">
    <button type="button" class="image-preview-close" aria-label="关闭" @click.stop="close">×</button>
    <img
      class="image-preview-img"
      :src="src"
      :alt="altText"
      @click.stop="close"
      @error="onImgError"
    />
  </div>
</template>

<script>
export default {
  name: "ImagePreviewLayer",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: "预览"
    }
  },
  computed: {
    altText() {
      const s = String(this.alt || "").trim();
      return s || "预览";
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onBackdrop() {
      this.close();
    },
    onImgError(e) {
      this.$emit("img-error", e);
    }
  }
};
</script>

<style scoped>
.image-preview-layer {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.7);
}

.image-preview-img {
  width: auto;
  max-width: 96vw;
  max-height: 92vh;
  object-fit: contain;
  border-radius: 14px;
  background: #111;
}

.image-preview-close {
  position: fixed;
  right: 16px;
  top: 14px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  z-index: 10051;
}
</style>
